// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-map-ContextMenuContent-module__wrapper {
    display: flex;
    flex-direction: column;
    max-width: 11em;
}

button.src-map-ContextMenuContent-module__entry div {
    margin-bottom: 2px;
    padding-right: 8px;
}

.src-map-ContextMenuContent-module__entry {
    display: flex;
    align-items: center;

    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    outline: inherit;
    font-size: 16px;
    padding: 0.15em 0.8em;
}

.src-map-ContextMenuContent-module__entry:hover {
    background-color: #ececec;
}

.src-map-ContextMenuContent-module__entry:active {
    background-color: #c6c6c6;
}

.src-map-ContextMenuContent-module__entry:disabled {
    color: lightgray;
}
`, "",{"version":3,"sources":["webpack://./src/map/ContextMenuContent.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    max-width: 11em;\n}\n\nbutton.entry div {\n    margin-bottom: 2px;\n    padding-right: 8px;\n}\n\n.entry {\n    display: flex;\n    align-items: center;\n\n    border: none;\n    background: none;\n    text-align: left;\n    cursor: pointer;\n    outline: inherit;\n    font-size: 16px;\n    padding: 0.15em 0.8em;\n}\n\n.entry:hover {\n    background-color: #ececec;\n}\n\n.entry:active {\n    background-color: #c6c6c6;\n}\n\n.entry:disabled {\n    color: lightgray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `src-map-ContextMenuContent-module__wrapper`,
	"entry": `src-map-ContextMenuContent-module__entry`
};
export default ___CSS_LOADER_EXPORT___;
